export const FRONT_PATH = 'localhost:3000';
// export const BECKEND_PATH = 'http://localhost/print_label_beckend/';
export const BECKEND_PATH = '/forms/';

export const realizacjeProdukt = {
  efiore: {
    title: "Oleje roślinne",
    content: () => (
      <p>
        Dla producenta naturalnych kosmetyków odświeżyliśmy wizerunek firmy,
        poprzez stworzenie nowych koncepcji etykiet do olejów naturalnych oraz
        serii innych produktów a w tym: szamponów, masek do włosów, peelingów,
        kremów, linii kosmetyków dla dzieci oraz linii serów hialuronowych -
        dobór odpowiednich dla tych kreacji materiałów oraz wydruk.
        <br />
        <br />
        Dodatkowo zrealizowaliśmy fotografię reklamową oraz stworzyliśmy
        wizualizacje na potrzeby sklepu.
        <br />
        <br />
        www.e-fiore.pl
      </p>
    ),
    views: [
      '../assets/products/efiore/view_1.jpg',
      '../assets/products/efiore/view_2.jpg',
      '../assets/products/efiore/view_3.jpg'
    ]
  },
  bassau: {
    title: 'Bassau',
    content: () => (
      <p>
        Dla producenta chemii basenowej stworzyliśmy etykiety produktów z nowej linii
        soli peelingowych, kadzideł naturalnych, kamieni do sauny, współgrających
        z istniejącą już koncepcją używanych przez firmę etykiet. Zrealizowaliśmy
        również projekt zakładający wykonanie fotografii produktowej.
        <br /><br />
        www.bassau.pl
      </p>
    ),
    views: [
      '../assets/products/bassau/view_1.jpg',
      '../assets/products/bassau/view_2.jpg',
      '../assets/products/bassau/view_3.jpg',
      '../assets/products/bassau/view_4.jpg'
    ]
  },
  glikol: {
    title: 'Glikol.com',
    content: () => (
      <p>
        Dla producenta glikolowych płynów instalacyjnych zaprojektowaliśmy
        i wydrukowaliśmy etykiety na opakowania płynu do chłodnic oraz zimowego
        i letniego płynu do spryskiwaczy. Realizujemy wydruki etykiet dla chemii
        budowlanej, instalacyjnej lub samochodowej.
        <br /><br />
        glikol.com
      </p>
    ),
    views: [
      '../assets/products/glikol/view_1.jpg'
    ]
  },
  miodowy_ogrod: {
    title: 'Miodowy ogród',
    content: () => (
      <p>
        Dla wytwórcy i sprzedawcy miodów zaprojektowaliśmy logotyp oraz etykiety
        na oferowane produkty. Wydrukowaliśmy również przygotowane przez nas katalogi,
        pocztówki, opakowania i standy. Stworzyliśmy wizualizacje na potrzeby sklepu.
        <br /><br />
        www.miodowyogrod.pl
      </p>
    ),
    views: [
      '../assets/products/miodowy_ogrod/view_1.jpg',
      '../assets/products/miodowy_ogrod/view_2.jpg',
      '../assets/products/miodowy_ogrod/view_3.jpg'
    ]
  },
  nails: {
    title: 'Nails',
    content: () => (
      <p>
        Dla producenta produktów do stylizacji paznokci, na mocy wieloletniej już
        współpracy, tworzymy etykiety do oferowanych przez niego produktów – opracowujemy
        koncepcje dla każdej z powstających linii, dobieramy materiały, wykonujemy
        fotografię produktową.
        <br /><br />
        www.nails.pl
      </p>
    ),
    views: [
      '../assets/products/nails/view_1.jpg',
      '../assets/products/nails/view_2.jpg',
      '../assets/products/nails/view_3.jpg',
      '../assets/products/nails/view_4.jpg'
    ]
  },
  nirobio: {
    title: 'Niro Bio',
    content: () => (
      <p>
        Dla producenta ekologicznej żywności odświeżyliśmy logotyp, stworzyliśmy
        koncepcję nowych etykiet na opakowania produktów sypkich – zaprojektowaliśmy
        i zrealizowaliśmy nowe etykiety, dobierając najlepsze dla realizacji materiały
        oraz pomysł i koncepcję graficzną.
        <br /><br />
        www.niro-bio.pl
      </p>
    ),
    views: [
      '../assets/products/nirobio/view_1.jpg',
      '../assets/products/nirobio/view_2.jpg',
      '../assets/products/nirobio/view_3.jpg',
      '../assets/products/nirobio/view_4.jpg'
    ]
  },
};
